import { useEffect } from "react";

export default function useTitle(title, deps) {
  useEffect(() => {
    const oldTitle = document.title;

    document.title = title;

    return function () {
      document.title = oldTitle;
    };
  }, deps);
}
